export const sectionStyles = {
  section: "py-16 px-0 sm:px-4",
  container: "flex flex-col max-w-full md:max-w-6xl mx-auto px-8 sm:px-12 lg:px-24 py-16 lg:py-20 gap-8 lg:gap-10 xl:gap-12 2xl:gap-16",
  title: "flex flex-col gap-2 mb-2 md:mb-6 lg:mb-2",
  breadcrumb: "hidden sm:flex text-sm items-center opacity-60 text-text-light dark:text-text-dark",
  heading: "text-3xl sm:text-4xl lg:text-5xl font-light leading-tight sm:leading-tight lg:leading-tight text-text-light dark:text-text-dark",
};